import { DateTime } from 'luxon';

export const getDaysAgoString = (dateOne: string): string => {
  const diff = DateTime.fromISO(dateOne).diff(DateTime.utc(), ['months', 'days', 'hours', 'years']).toObject();

  switch (true) {
    case diff.years && diff.years === -1:
      return `year ago`;
    case diff.years && diff.years < -1:
      return `${-Math.round(diff.years!)} years ago`;
    case diff.months && diff.months === -1:
      return `month ago`;
    case diff.months && diff.months < -1:
      return `${-Math.round(diff.months!)} months ago`;
    case diff && diff.days === 0:
      return 'today';
    case diff && diff.days === -1:
      return 'yesterday';
    default:
      return `${-Math.round(diff.days!)} days ago`;
  }
};
